<ng-container *ngIf="isScreenLarge; else mobileLayout">
  <div class="main-tab-title-box">
    <mat-card-title class="main-title">Summary</mat-card-title>
    <div>
      <analysis-options></analysis-options>
    </div>
  </div>
  <div *ngIf="loaderActive" class="div_loader_pag">
    <div id="div_loader_pag">
      <div class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysis will begin after you finish typing</div>
  </div>
  <div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
    <div id="div_loader_pag">
      <div class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysing and Saving</div>
  </div>
  <div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
    <div id="div_loader_pag">
      <div class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysing...</div>
  </div>
  <mat-card-content>
    <div *ngIf="summary.cefr !== null && summary.cefr !== undefined">
      <span class="main-box-title-14">Click on one of the measures in the boxes below for more details.</span>
    </div>
    <div id="summary-box" style="grid-column: span 2; margin-top: 5px; cursor: pointer;">
      <div class="main-box-title-16">CEFR Level ({{ currentAnalysisMode }})
        <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text2">The CEFR (Common European Framework of Reference for Languages) is a framework that helps describe language proficiency in a foreign language using a scale from A1 (Beginner) to C2 (Proficiency). 
            <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer">
              Read more
            </a>
            </span>
        </div>
      </div>
      <div class="main-box-value-48" style="margin-top: 15px; margin-bottom: 15px;">{{summary.cefr ? summary.cefr:"--"}}
      </div>
      <div *ngIf="summary.cefr !== null && summary.cefr !== undefined">
        <div class="scorecard-title" style="text-align: center;">Key to CEFR Levels</div>
        <div class="scorecard-box-sub scroll_scores" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}"
              style="margin-left: 8px;">
              A1
            </div>
            <div class="little-title">Beginner <br> <span style="visibility: hidden;">Intermediate</span></div>
          </div>
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}"
              style="margin-left: 7px;">
              A2
            </div>
            <div class="little-title">Elementary <br> <span style="visibility: hidden;">Intermediate</span></div>
          </div>
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}"
              style="margin-left: 8px;">
              B1
            </div>
            <div class="little-title">Intermediate <br> <span style="visibility: hidden;">Intermediate</span></div>
          </div>
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}"
              style="margin-left: 7px;">
              B2
            </div>
            <div class="little-title">Upper <br> Intermediate</div>
          </div>
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}"
              style="margin-left: 7px;">
              C1
            </div>
            <div class="little-title">Advanced <br> <span style="visibility: hidden;">Intermediate</span></div>
          </div>
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}"
              style="margin-left: 8px;">
              C2
            </div>
            <div class="little-title">Proficiency <br> <span style="visibility: hidden;">Intermediate</span></div>
          </div>
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}"
              style="margin-left: 8px;">
              D1
            </div>
            <div class="little-title">Academic <br> <span style="visibility: hidden;">Intermediate</span></div>
          </div>
          <div class="vertical-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('D2'), 'not-matching': !isMatchingLevel('D2')}"
              style="margin-left: 3px; ">
              D2
            </div>
            <div class="little-title">Upper <br> Academic</div>
          </div>
        </div>
      </div>
      <div *ngIf="cefr_short_words" class="message">
        <div class="line"></div>
        <p>CEFR score are not accurate on short documents.</p>
      </div>

    </div>
    <div class="summary-grid scroll-grid">
      <div class="vertical-box-summary" style=" cursor: pointer; min-width: 260px;" (click)="onSelectMenuItem('readability')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px; margin-bottom: 0px;">
          <div class="main-box-title-16" style="text-align: left;">Flesch-Kincaid Grade</div>
          <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_flesch_kincaid">{{getFleschKincaidDisplay()}}</div>
          <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        </div>
        <div *ngIf="isThereProject && summary2.flesch_kincaid !== undefined && !loaderActiveSummary2"
          style="position: relative; bottom: 0;">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
            <mat-progress-bar mode="determinate" value="{{summary2.flesch_kincaid}}" color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorKincaid(summary2.flesch_kincaid)" class="box-line">
            <div class="main-box-title-12">{{getTextLineFlesch(summary2.flesch_kincaid)}}</div>
          </div>
        </div>
      </div>

      <div class="vertical-box-summary" style="cursor: pointer; min-width: 260px;"
        (click)="onSelectMenuItem('lexicalDiversity')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px; margin-bottom: 0px;">
          <div class="main-box-title-16" style="text-align: left;">Lexical Diversity (VOCD)</div>
          <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_lexical">{{getLexicalDisplay()}}</div>
          <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        </div>
        <div *ngIf="isThereProject && summary2.lexical !== undefined && !loaderActiveSummary2">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
            <mat-progress-bar mode="determinate" value="{{summary2.lexical}}" color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorVOCD(summary2.lexical)" class="box-line">
            <div class="main-box-title-12">{{ getTextLineLexical(summary2.lexical)}}</div>
          </div>
        </div>
      </div>

      <div class="vertical-box-summary" style=" cursor: pointer; min-width: 260px;" (click)="onSelectMenuItem('awl')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px; margin-bottom: 0px;">
          <div class="main-box-title-16" style="text-align: left;">Percentage of Academic Words (Tokens)</div>
          <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_academic">{{getAcademicDisplay()}}</div>
          <div *ngIf="loaderActiveSummary3" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        </div>
        <div *ngIf="isThereProject && summary3.academic !== undefined && !loaderActiveSummary3">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
            <mat-progress-bar mode="determinate" [value]="mapToPercentage(summary3.academic/3.10)"
              color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorAcademic(summary3.academic)" class="box-line">
            <div class="main-box-title-12">{{getTextLineAcademic(summary3.academic)}}</div>
          </div>
        </div>
      </div>

      <div class="vertical-box-summary" style=" cursor: pointer; min-width: 260px;" (click)="onSelectMenuItem('evp')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px; margin-bottom: 0px;">
          <div class="main-box-title-16" style="text-align: left;">Percentage of Tokens at B1 CEFR Level
          </div>
          <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_words_level">{{getWordsLevelDisplay()}}</div>
          <div *ngIf="loaderActiveSummary3" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        </div>
        <div *ngIf="isThereProject && summary3.words_level !== undefined && !loaderActiveSummary3">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
            <mat-progress-bar mode="determinate" [value]="((100-(summary3.words_level-6))/300)*100"
              color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorWordsLevel(summary3.words_level)" class="box-line">
            <div class="main-box-title-12">{{getTextLineWordsLevel(summary3.words_level)}}</div>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="lexical_short_words" class="message">
      <div class="line"></div>
      <p>Lexical score are not accurate on short documents.</p>
    </div>
    <div *ngIf="short_words" class="message">
      <div class="line"></div>
      <p>Scores are not accurate on short documents.</p>
    </div>
    <div class="summary-grid"></div><!--ESPACIO-->
    <div class="horizontal-box">
      <div class="main-box-title-14">
        <img *ngIf="summary.sentence_count !== null && summary.sentence_count !== undefined && !hideEyeIconsForSafari1561"  class="eye-icon eye-text"
          src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Sentence($event, summary.sentences_data)">
        Sentence count
      </div>
      <div *ngIf="!loaderActiveSummary1" class="main-box-value-16-bold">{{summary.sentence_count ? summary.sentence_count:"--"}}</div>
      <div *ngIf="loaderActiveSummary1" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14">
        <img *ngIf="summary2.word_count !== null && summary2.word_count !== undefined && !hideEyeIconsForSafari1561" class="eye-icon eye-text"
          src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Words($event, summary2.word_data)">
        Token count (similar to word count) <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">
            Tokens are similar to words, but include punctuation and other elements.
          </span>
        </div>
        <span *ngIf="excludeDigits">, (excluding numbers)</span>
      </div>
      <div *ngIf="!loaderActiveSummary2" class="main-box-value-16-bold">{{summary2.word_count ? summary2.word_count:"--"}}</div>
      <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
    </div>

    <div *ngIf="summary.llego_a_cefr == 1 && !loaderActiveSummary4">
      <div class="summary-grid space"></div>
      <div class="main-box-value-16-bold horizontal-items" style="margin-bottom: 10px;">Suggestions on how to modify your text to reach your target CEFR level.</div>
      <div class="main-box-title-14 horizontal-items">Number of possible modifications to reach your CEFR Level Target: <div class="main-box-value-16-bold"style="margin-left: 6px;">{{countKeys(summary4.activar) ? countKeys(summary4.activar):"--"}}</div>
      </div>
      <div class="space2"></div>
      <span class="main-box-title-14">Below you can see several statistics that could be modified in order to reach your Target CEFR Level of <div class="main-box-value-16-bold" style="margin-left: 0px;margin-right: 0px;display: inline-block;">{{DesiredCEFRLevel}}</div>. Click on the "eye" icon next to each statistic, and it will be highlighted in the text for you.</span>
    </div>


    <div *ngIf="summary.llego_a_cefr == -1 && !loaderActiveSummary4">
      <div class="summary-grid space"></div>
      <div class="main-box-value-16-bold horizontal-items" style="margin-bottom: 10px;">Suggestions on how to modify your text to reach your target CEFR level.</div>
      <div class="main-box-title-14 horizontal-items">Number of possible modifications to reach your CEFR Level Target: <div class="main-box-value-16-bold"style="margin-left: 6px;">{{countKeys(summary4.activar) ? countKeys(summary4.activar):"--"}}</div></div>
      <div class="space2"></div>
      <!-- <span class="main-box-title-14">Click on the ‘<img class="eye-icon eye-text" style="margin-right: 0px;"
          src="./assets/images/eye-icon.svg">‘ icons below to highlight the relevant sections in your text. Click on a
        metric to be taken to the relevant section of Text Inspector.</span> -->
      <span class="main-box-title-14">Below you can see several statistics that could be modified in order to reach your Target CEFR Level of <div class="main-box-value-16-bold" style="margin-left: 0px;margin-right: 0px;display: inline-block;">{{DesiredCEFRLevel}}</div>. Click on the "eye" icon next to each statistic, and it will be highlighted in the text for you.</span>
    </div>

    <!-- Metricas (Aqui estan todas las metricas, ya no las separamos por tipo de texto, solo revisamos cuales van a ser activadas) -->

    <div *ngIf="loaderActiveSummary4" class="div_loader_pag" style="margin-bottom: 0px; margin-top: 30px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>


    <ng-container *ngIf="summary.llego_a_cefr != 0 && !loaderActiveSummary4">
      <!-- Words with more than 2 syllabes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Wordswithmorethan2syllables">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.Wordswithmorethan2syllables.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Wordswithmorethan2syllables.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Words with more than 2 syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Wordswithmorethan2syllables.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes615">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes615.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes615.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 6 to 15 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes615.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes1115">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes1115.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes1115.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 11 to 15 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes1115.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes1620">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes1620.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes1620.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 16 to 20 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes1620.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes2125">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes2125.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes2125.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 21 to 25 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes2125.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes2630">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes2630.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes2630.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 26 to 30 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes2630.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes3135">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes3135.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes3135.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 31 to 35 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes3135.value}}</div>
      </div>
      <!-- Oraciones con más de X Silabas -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes31">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes31.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes31.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with more than 30 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes31.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes36">

        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes36.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes36.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 35 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes36.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan6Words">

        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan6Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan6Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 6 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan6Words.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan10Words">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan10Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan10Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 10 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan10Words.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan15Words">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan15Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan15Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with more than 15 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan15Words.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan20Words">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan20Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan20Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 20 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan20Words.value}}</div>
      </div>
      <!-- Oraciones entre X & Y Palabras -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences510">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences510.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.Sentences510.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 5 to 10 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences510.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences1115">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences1115.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences1115.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 11 to 15 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences1115.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences1620">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences1620.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences1620.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 16 to 20 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences1620.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences2125">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences2125.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences2125.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 21 to 25 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences2125.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences2630">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences2630.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences2630.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 26 to 30 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences2630.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences31">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences31.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.Sentences31.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 30 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences31.value}}</div>
      </div>

      <!-- Number of Unique Words -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.NumberofUniqueWords">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.NumberofUniqueWords.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.NumberofUniqueWords.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Number of unique words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.NumberofUniqueWords.value}}</div>
      </div>
      <!-- Verbal Elemnts Per Sentence -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.VerbalElemntsPerSentence">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.VerbalElemntsPerSentence.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.VerbalElemntsPerSentence.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Verbal Elemnts Per Sentence
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.VerbalElemntsPerSentence.value}}</div>
      </div>
      <!-- Noun Elements Per Sentence -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.NounElementsPerSentence">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.NounElementsPerSentence.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.NounElementsPerSentence.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Noun Elements Per Sentence
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.NounElementsPerSentence.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtA1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsA1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsA1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsA1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at A1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsA1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtB1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsB1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsB1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsB1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at B1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsB1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtB2Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsB2">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsB2.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsB2.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at B2 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsB2.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtC1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsC1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsC1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsC1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at C1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsC1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTokensAtB1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPTokensB1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPTokensB1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPTokensB1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Tokens) at B1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPTokensB1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTokensAtB2Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPTokensB2">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPTokensB2.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPTokensB2.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Tokens) at B2 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPTokensB2.value}}</div>
      </div>
      <!-- BNC Mean LFC Score -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.bncmeanlfc">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.bncmeanlfc.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.bncmeanlfc.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: Mean LFC per 100 types
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.bncmeanlfc.value}}</div>
      </div>
      <!-- bncPercentOfWordsTypesAt01kLevel -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCWords01K">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCWords01K.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCWords01K.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: Percent (%) of Words (Types) at 0-1K Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCWords01K.value}}</div>
      </div>
      <!-- bncPercentOfWordsTypesAt1020kLevel -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCWords1020K">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCWords1020K.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.BNCWords1020K.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: Percent (%) of Words (Types) at 10-20K Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCWords1020K.value}}</div>
      </div>
      <!-- bnc50thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent50">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent50.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent50.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 50th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent50.value}}</div>
      </div>
      <!-- bnc60thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent60">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent60.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent60.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 60th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent60.value}}</div>
      </div>
      <!-- bnc70thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent70">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent70.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent70.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 70th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent70.value}}</div>
      </div>
      <!-- bnc80thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent80">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent80.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent80.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 80th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent80.value}}</div>
      </div>
      <!-- COCA Mean LFC Score -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.cocameanlfc">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.cocameanlfc.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.cocameanlfc.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: Mean LFC per 100 types
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.cocameanlfc.value}}</div>
      </div>
      <!-- cocaPercentOfWordsTypesAt1020kLevel -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAWords1020K">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAWords1020K.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAWords1020K.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: Percent (%) of Words (Types) at 10-20K Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAWords1020K.value}}</div>
      </div>
      <!-- coca50thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent50">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent50.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent50.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 50th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent50.value}}</div>
      </div>
      <!-- coca60thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent60">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent60.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent60.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 60th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent60.value}}</div>
      </div>
      <!-- coca70thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent70">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent70.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent70.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 70th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent70.value}}</div>
      </div>
      <!-- coca80thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent80">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent80.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent80.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 80th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent80.value}}</div>
      </div>
      <!-- academicWordListPercentOfAllAwlWordsTypesInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.AWLWords">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.AWLWords.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.AWLWords.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Academic Words (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.AWLWords.value}}</div>
      </div>
      <!-- academicWordListPercentOfAllAwlWordsTokensInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.AWLTokens">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.AWLTokens.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.AWLTokens.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Academic Words (Tokens)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.AWLTokens.value}}</div>
      </div>
      <!-- metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.MetadiscourseWords">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.MetadiscourseWords.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.MetadiscourseWords.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Metadiscourse Markers (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.MetadiscourseWords.value}}</div>
      </div>
      <!-- metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.MetadiscourseTypes">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.MetadiscourseTypes.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.MetadiscourseTypes.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Metadiscourse Markers (Tokens)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.MetadiscourseTypes.value}}</div>
      </div>

    </ng-container>


  </mat-card-content>

</ng-container>

<!------------------>
<!------------------>
<!------------------>
<!------------------>

<ng-template #mobileLayout>
  <div class="main-tab-title-box">
    <mat-card-title class="main-title">Summary</mat-card-title>
    <div>
      <analysis-options></analysis-options>
    </div>
  </div>

  <div *ngIf="loaderActive" class="div_loader_pag">
    <div id="div_loader_pag">
      <div class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysis will begin after you finish typing</div>
  </div>
  <div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
    <div id="div_loader_pag">
      <div class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysing and Saving</div>
  </div>
  <div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
    <div id="div_loader_pag">
      <div class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysing...</div>
  </div>

  <mat-card-content>
    <div id="summary-box" style="grid-column: span 2; cursor: pointer;" (click)="onSelectMenuItem('scorecard')">
      <div class="main-box-title-16">CEFR Level ({{ currentAnalysisMode }}) <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text2">The CEFR (Common European Framework of References for Languages) is a framework
            that helps describe language proficiency in a foreign language using a scale from A1 (Beginner) to C2
            (Proficiency). <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks"
              target="_blank" rel="noopener noreferrer">Read more</a></span>
        </div>
      </div>
      <div class="main-box-value-48" style="margin-top: 15px; margin-bottom: 15px;">{{summary.cefr ? summary.cefr:"--"}}
      </div>
      <div *ngIf="summary.cefr !== null && summary.cefr !== undefined">
        <div class="scorecard-title" style="text-align: center;">Key to CEFR Levels</div>
        <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}"
              style="margin-left: 8px;">
              A1
            </div>
            <div class="little-title">Beginner</div>
          </div>
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}"
              style="margin-left: 8px;">
              A2
            </div>
            <div class="little-title">Elementary</div>
          </div>
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}"
              style="margin-left: 8px;">
              B1
            </div>
            <div class="little-title">Intermediate</div>
          </div>
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}"
              style="margin-left: 8px; margin-top: 18px;">
              B2
            </div>
            <div class="little-title">Upper <br> Intermediate</div>
          </div>
        </div>

        <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}"
              style="margin-left: 8px;">
              C1
            </div>
            <div class="little-title">Advanced</div>
          </div>
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}"
              style=" margin-left: 8px;">
              C2
            </div>
            <div class="little-title">Proficiency</div>
          </div>
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}"
              style="margin-left: 8px;">
              D1
            </div>
            <div class="little-title">Academic</div>
          </div>
          <div class="vertical-box cefr-box" style="border: none;">
            <div class="scorecard-score-box"
              [ngClass]="{'matching': isMatchingLevel('D2'), 'not-matching': !isMatchingLevel('D2')}"
              style="margin-left: 8px; margin-top: 17px;">
              D2
            </div>
            <div class="little-title">Upper <br> Academic</div>
          </div>
        </div>
      </div>
      <div *ngIf="cefr_short_words" class="message">
        <div class="line"></div>
        <p>CEFR score are not accurate on short documents.</p>
      </div>
    </div>
    <div class="summary-grid">
      <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;" (click)="onSelectMenuItem('readability')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px; height: 35px; justify-content: center;">
          <div class="main-box-title-16" style="text-align: center;">Flesch-Kincaid Grade</div>
        </div>
        <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_flesch_kincaid">{{getFleschKincaidDisplay()}}</div>
          <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom:20px">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        <div *ngIf="isThereProject && summary2.flesch_kincaid !== undefined && !loaderActiveSummary2" style="height: 100%;">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
            <mat-progress-bar mode="determinate" value="{{summary2.flesch_kincaid}}" color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorKincaid(summary2.flesch_kincaid)">
            <div class="main-box-title-12">{{getTextLineFlesch(summary2.flesch_kincaid)}}</div>
          </div>
        </div>
      </div>

      <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;"
        (click)="onSelectMenuItem('lexicalDiversity')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px;height: 35px;justify-content: center;">
          <div class="main-box-title-16" style="text-align: center;">Lexical Diversity (VOCD)</div>
        </div>
        <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_lexical">{{getLexicalDisplay()}}</div>
         <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom:20px">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        <div *ngIf="isThereProject && summary2.lexical !== undefined && !loaderActiveSummary2">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
            <mat-progress-bar mode="determinate" value="{{summary2.lexical}}" color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorVOCD(summary2.lexical)">
            <div class="main-box-title-12">{{ getTextLineLexical(summary2.lexical)}}<span
                style="visibility: hidden;">000Reading Level sdfsf</span></div>
          </div>
        </div>
      </div>

      <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;" (click)="onSelectMenuItem('awl')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px;height: 60px;justify-content: center;">
          <div class="main-box-title-16" style="text-align: center;">Percentage of Academic Words (Tokens)</div>

        </div>
        <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_academic">{{getAcademicDisplay()}}</div>
         <div *ngIf="loaderActiveSummary3" class="div_loader_pag" style="margin-bottom:20px">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        <div *ngIf="isThereProject && summary3.academic !== undefined && !loaderActiveSummary3">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;justify-content: center;">
            <mat-progress-bar mode="determinate" [value]="mapToPercentage(summary3.academic/3.10)"
              color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorAcademic(summary3.academic)">
            <div class="main-box-title-12">{{getTextLineAcademic(summary3.academic)}}<span
                style="visibility: hidden;">sdf</span></div>
          </div>
        </div>
      </div>

      <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;" (click)="onSelectMenuItem('evp')">
        <div class="horizontal-box" style="border: none; padding-bottom: 0px;height: 60px;">
          <div class="main-box-title-16" style="text-align: center;">Percentage of Tokens at B1 CEFR Level</div>
        </div>
        <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_words_level">{{getWordsLevelDisplay()}}
        </div>
        <div *ngIf="loaderActiveSummary3" class="div_loader_pag" style="margin-bottom:20px">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
        <div *ngIf="isThereProject && summary3.words_level !== undefined && !loaderActiveSummary3">
          <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
            <mat-progress-bar mode="determinate" [value]="((100-(summary3.words_level-6))/300)*100"
              color="accent"></mat-progress-bar>
          </div>
          <div [ngClass]="getBoxLineColorWordsLevel(summary3.words_level)">
            <div class="main-box-title-12">{{getTextLineWordsLevel(summary3.words_level)}}</div>
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="lexical_short_words" class="message">
      <div class="line"></div>
      <p>Lexical score are not accurate on short documents.</p>
    </div>
    <div *ngIf="short_words" class="message">
      <div class="line"></div>
      <p>Scores are not accurate on short documents.</p>
    </div>
    <div class="summary-grid"></div><!--ESPACIO-->
    <div class="horizontal-box">
      <div class="main-box-title-14">
        <img *ngIf="summary.sentence_count !== null && summary.sentence_count !== undefined && !hideEyeIconsForSafari1561" class="eye-icon eye-text"
          src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Sentence($event, summary.sentences_data)">
        Sentence count
      </div>
      <div *ngIf="!loaderActiveSummary1" class="main-box-value-16-bold">{{summary.sentence_count ? summary.sentence_count:"--"}}</div>
       <div *ngIf="loaderActiveSummary1" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14">
        <img *ngIf="summary2.word_count !== null && summary2.word_count !== undefined && !hideEyeIconsForSafari1561" class="eye-icon eye-text"
          src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Words($event, summary2.word_data)">
        Token count (similar to word count) <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">
            Tokens are similar to words, but include punctuation and other elements.
          </span>
        </div>
        <span *ngIf="excludeDigits">, (excluding numbers)</span>
      </div>
      <div *ngIf="!loaderActiveSummary2" class="main-box-value-16-bold">{{summary2.word_count ? summary2.word_count:"--"}}</div>
       <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
    </div>
    <div *ngIf="summary.llego_a_cefr == 1 && !loaderActiveSummary4">
      <div class="summary-grid space"></div>
      <div class="main-box-value-16-bold horizontal-items" style="margin-bottom: 10px;">Suggestions on how to modify your text to reach your target CEFR level.</div>
      <div class="main-box-title-14 horizontal-items">Number of possible modifications to reach your CEFR Level Target: <div class="main-box-value-16-bold"
          style="margin-left: 6px;">{{countKeys(summary4.activar) ? countKeys(summary4.activar):"--"}}</div>
      </div>
      <div class="space2"></div>
      <span class="main-box-title-14">Below you can see several statistics that could be modified in order to reach your Target CEFR Level of <div class="main-box-value-16-bold" style="margin-left: 0px;margin-right: 0px;display: inline-block;">{{DesiredCEFRLevel}}</div>. Click on the "eye" icon next to each statistic, and it will be highlighted in the text for you.</span>
    </div>


    <div *ngIf="summary.llego_a_cefr == -1 && !loaderActiveSummary4">
      <div class="summary-grid space"></div>
      <div class="main-box-value-16-bold horizontal-items" style="margin-bottom: 10px;">Suggestions on how to modify your text to reach your target CEFR level.</div>
      <div class="main-box-title-14 horizontal-items">Number of possible modifications to reach your CEFR Level Target: <div class="main-box-value-16-bold"style="margin-left: 6px;">{{countKeys(summary4.activar) ? countKeys(summary4.activar):"--"}}</div></div>
      <div class="space2"></div>
      <!-- <span class="main-box-title-14">Click on the ‘<img class="eye-icon eye-text" style="margin-right: 0px;"
          src="./assets/images/eye-icon.svg">‘ icons below to highlight the relevant sections in your text. Click on a
        metric to be taken to the relevant section of Text Inspector.</span> -->
      <span class="main-box-title-14">Below you can see several statistics that could be modified in order to reach your Target CEFR Level of <div class="main-box-value-16-bold" style="margin-left: 0px;margin-right: 0px;display: inline-block;">{{DesiredCEFRLevel}}</div>. Click on the "eye" icon next to each statistic, and it will be highlighted in the text for you.</span>
    </div>

    <!-- Metricas Writing -->
     <div *ngIf="loaderActiveSummary4" class="div_loader_pag" style="margin-bottom: 0px; margin-top: 30px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>

    <ng-container *ngIf="summary.llego_a_cefr != 0 && !loaderActiveSummary4">
      <!-- Words with more than 2 syllabes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Wordswithmorethan2syllables">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.Wordswithmorethan2syllables.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Wordswithmorethan2syllables.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Words with more than 2 syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Wordswithmorethan2syllables.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes615">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes615.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes615.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 6 to 15 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes615.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes1115">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes1115.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes1115.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 11 to 15 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes1115.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes1620">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes1620.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes1620.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 16 to 20 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes1620.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes2125">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes2125.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes2125.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 21 to 25 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes2125.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes2630">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes2630.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes2630.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 26 to 30 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes2630.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes3135">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes3135.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes3135.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with 31 to 35 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes3135.value}}</div>
      </div>
      <!-- Oraciones con más de X Silabas -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes31">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes31.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes31.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with more than 30 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes31.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesSyllabes36">

        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesSyllabes36.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesSyllabes36.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 35 Syllables
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesSyllabes36.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan6Words">

        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan6Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan6Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 6 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan6Words.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan10Words">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan10Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan10Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 10 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan10Words.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan15Words">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan15Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan15Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Sentences with more than 15 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan15Words.value}}</div>
      </div>
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.SentencesMoreThan20Words">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.SentencesMoreThan20Words.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.SentencesMoreThan20Words.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 20 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.SentencesMoreThan20Words.value}}</div>
      </div>
      <!-- Oraciones entre X & Y Palabras -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences510">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences510.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.Sentences510.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 5 to 10 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences510.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences1115">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences1115.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences1115.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 11 to 15 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences1115.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences1620">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences1620.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences1620.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 16 to 20 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences1620.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences2125">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences2125.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences2125.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 21 to 25 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences2125.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences2630">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences2630.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.Sentences2630.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with 26 to 30 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences2630.value}}</div>
      </div>

      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.Sentences31">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon_Sentence($event, summary4.activar.Sentences31.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.Sentences31.eye_data.length != 0 && !hideEyeIconsForSafari1561">

        <div class="main-box-title-14">
          Sentences with more than 30 words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.Sentences31.value}}</div>
      </div>

      <!-- Number of Unique Words -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.NumberofUniqueWords">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.NumberofUniqueWords.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.NumberofUniqueWords.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Number of unique words
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.NumberofUniqueWords.value}}</div>
      </div>
      <!-- Verbal Elemnts Per Sentence -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.VerbalElemntsPerSentence">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.VerbalElemntsPerSentence.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.VerbalElemntsPerSentence.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Verbal Elemnts Per Sentence
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.VerbalElemntsPerSentence.value}}</div>
      </div>
      <!-- Noun Elements Per Sentence -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.NounElementsPerSentence">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.NounElementsPerSentence.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.NounElementsPerSentence.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Noun Elements Per Sentence
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.NounElementsPerSentence.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtA1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsA1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsA1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsA1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at A1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsA1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtB1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsB1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsB1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsB1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at B1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsB1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtB2Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsB2">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsB2.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsB2.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at B2 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsB2.value}}</div>
      </div>
      <!-- evpPercentOfWordsTypesAtC1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPWordsC1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPWordsC1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPWordsC1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Types) at C1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPWordsC1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTokensAtB1Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPTokensB1">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPTokensB1.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPTokensB1.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Tokens) at B1 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPTokensB1.value}}</div>
      </div>
      <!-- evpPercentOfWordsTokensAtB2Level -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.EVPTokensB2">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.EVPTokensB2.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.EVPTokensB2.eye_data.length != 0  && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          EVP: Percent (%) of Words (Tokens) at B2 Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.EVPTokensB2.value}}</div>
      </div>
      <!-- BNC Mean LFC Score -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.bncmeanlfc">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.bncmeanlfc.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.bncmeanlfc.eye_data.length != 0  && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: Mean LFC per 100 types
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.bncmeanlfc.value}}</div>
      </div>
      <!-- bncPercentOfWordsTypesAt01kLevel -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCWords01K">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCWords01K.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCWords01K.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: Percent (%) of Words (Types) at 0-1K Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCWords01K.value}}</div>
      </div>
      <!-- bncPercentOfWordsTypesAt1020kLevel -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCWords1020K">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCWords1020K.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.BNCWords1020K.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: Percent (%) of Words (Types) at 10-20K Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCWords1020K.value}}</div>
      </div>
      <!-- bnc50thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent50">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent50.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent50.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 50th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent50.value}}</div>
      </div>
      <!-- bnc60thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent60">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent60.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent60.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 60th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent60.value}}</div>
      </div>
      <!-- bnc70thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent70">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent70.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent70.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 70th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent70.value}}</div>
      </div>
      <!-- bnc80thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.BNCPercent80">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.BNCPercent80.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.BNCPercent80.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          BNC: 80th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.BNCPercent80.value}}</div>
      </div>
      <!-- COCA Mean LFC Score -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.cocameanlfc">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.cocameanlfc.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.cocameanlfc.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: Mean LFC per 100 types
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.cocameanlfc.value}}</div>
      </div>
      <!-- cocaPercentOfWordsTypesAt1020kLevel -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAWords1020K">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAWords1020K.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAWords1020K.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: Percent (%) of Words (Types) at 10-20K Level
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAWords1020K.value}}</div>
      </div>
      <!-- coca50thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent50">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent50.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent50.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 50th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent50.value}}</div>
      </div>
      <!-- coca60thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent60">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent60.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent60.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 60th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent60.value}}</div>
      </div>
      <!-- coca70thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent70">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent70.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent70.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 70th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent70.value}}</div>
      </div>
      <!-- coca80thPercentileTypes -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.COCAPercent80">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.COCAPercent80.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.COCAPercent80.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          COCA: 80th Percentile (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.COCAPercent80.value}}</div>
      </div>
      <!-- academicWordListPercentOfAllAwlWordsTypesInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.AWLWords">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.AWLWords.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.AWLWords.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Academic Words (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.AWLWords.value}}</div>
      </div>
      <!-- academicWordListPercentOfAllAwlWordsTokensInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.AWLTokens">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.AWLTokens.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}" *ngIf="summary4.activar.AWLTokens.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Academic Words (Tokens)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.AWLTokens.value}}</div>
      </div>
      <!-- metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.MetadiscourseWords">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.MetadiscourseWords.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.MetadiscourseWords.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Metadiscourse Markers (Types)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.MetadiscourseWords.value}}</div>
      </div>
      <!-- metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText -->
      <div class="horizontal-box" style="margin-top: 10px;" *ngIf="summary4.activar?.MetadiscourseTypes">
        <img class="eye-icon" src="./assets/images/eye-icon.svg"
          (click)="!isButtonDisabled() && toggleEyeIcon($event, summary4.activar.MetadiscourseTypes.eye_data)"
          [ngClass]="{'disabled-button': isButtonDisabled()}"
          *ngIf="summary4.activar.MetadiscourseTypes.eye_data.length != 0 && !hideEyeIconsForSafari1561">
        <div class="main-box-title-14">
          Percent (%) of all Metadiscourse Markers (Tokens)
        </div>
        <div class="main-box-value-16-bold">{{summary4.activar.MetadiscourseTypes.value}}</div>
      </div>

    </ng-container>

  </mat-card-content>

</ng-template>